import { Box, Flex, Stack, Text, useMantineTheme } from "@mantine/core";
import { useStyles } from "./UsageGraph.styled";
import { IUsageGraphProps } from "./types";
import { formatQuantity } from "@common/utils/string";

export default function UsageGraph({
  hasQuota,
  usage,
  prepaidUnits,
  metricLabel,
  maxLabel,
  ...stackProps
}: IUsageGraphProps) {
  const theme = useMantineTheme();
  const { classes } = useStyles();

  const utilizationValue = prepaidUnits > 0 ? (100 * usage) / prepaidUnits : 0;
  const utilizationPercent = Math.round(utilizationValue);
  const utilizationStr =
    utilizationPercent === 0 ? "1%" : `${utilizationPercent}%`;

  return (
    <Stack spacing={theme.spacing.xs / 2} {...stackProps}>
      <Flex
        align="center"
        direction="row"
        gap="xl"
        justify="space-between"
        wrap="nowrap"
        w="100%"
      >
        <Text fz="sm">{metricLabel}</Text>
        <Text fz="sm">
          {hasQuota ? formatQuantity(usage, 1) : "No data"}
          {maxLabel != null && ` / ${maxLabel}`}
        </Text>
      </Flex>

      <Box pos="relative">
        <Box className={classes.graphContainer} pos="relative">
          <Box
            // TODO: Add #E7F2DB to mantine theme
            bg={hasQuota ? "#E7F2DB" : "gray.2"}
            h="xl"
            w="100%"
          />
          {utilizationValue > 0 && (
            <Box
              bg="green.1"
              h="100%"
              left={0}
              pos="absolute"
              top={0}
              data-testid="usage-fill-bar"
              w={utilizationStr}
            />
          )}
        </Box>
      </Box>
    </Stack>
  );
}
